import "../modules/htmx-global";

import "../modules/navbar";
import "../modules/footer";
import "../modules/unmarketable-destination-modal";

import Alpine from "../modules/alpine-global";
import { copyToClipboard } from "../utils/clipboard.mjs";
import { DestinationNavbarSticky } from "../modules/destination-navbar";

window.copyToClipboard = copyToClipboard;

// Start Alpine when document is ready
document.addEventListener('DOMContentLoaded', () => {
    Alpine.start();

    // Self-guards: does nothing on pages without `.destination-navbar` (home, etc.)
    new DestinationNavbarSticky();
});
